import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Product } from "../../Domain/Model/Product";
import { ProductGallery } from "../../Domain/Model/ProductGallery";
import { Products } from "../../Domain/Model/Products";
import { ProductState } from "../../Domain/Model/ProductState";
import { ProductRepository } from "../../Domain/Repository/ProductRepository";
import { ProductsAPIEntity } from "../DataSource/API/Entity/ProductsAPIEntity";
import ProductDataSource from "../DataSource/ProductDataSource";

export class ProductRepositoryImpl implements ProductRepository {
  dataSource: ProductDataSource;

  constructor(_datasource: ProductDataSource) {
    this.dataSource = _datasource;
  }
  getProducts(page: number, pageSize: number, search: string): Promise<PaginationResult<Products>> {
    return this.dataSource.getProducts(page, pageSize, search);
  }
  getProductById(productId: number): Promise<Product | null> {
    return this.dataSource.getProductById(productId);
  }
   createProduct(data: Product): Promise<number> {
    return this.dataSource.createProduct(data);
  }
  updateProduct(data: Product): Promise<boolean> {
    return this.dataSource.updateProduct(data);
  }
  updateTableProduct(data: ProductsAPIEntity): Promise<boolean> {
    return this.dataSource.updateTableProduct(data);
  }
  updateStateProduct(data: ProductState): Promise<boolean> {
    return this.dataSource.updateStateProduct(data);
  }
  uploadProductGallery(data: ProductGallery): Promise<boolean> {
    return this.dataSource.uploadProductGallery(data);
  }
  viewProductGalleryById(productId: number): Promise<any> {
    return this.dataSource.viewProductGalleryById(productId);
  }
  setMainImage(data: any):Promise<string | undefined>{
    return this.dataSource.setMainImage(data);
  }
  viewMainImage(productId: number):Promise<string | undefined>{
    return this.dataSource.viewMainImage(productId);
  }
  deleteProductGallery(id: number): Promise<boolean>{
    return this.dataSource.deleteProductGallery(id);
  }
}